var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-5 pb-6 card border-rad-1-2"},[_c('div',[_c('QuestionResponseBars',{attrs:{"display-data":_vm.displayData,"assigned-colors":_vm.assignedColors}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }